module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red-671bc30eff4b58b2a8a2e926bfaffc7c.png";